import DefaultCodes from './DefaultCodes';

export default DefaultCodes;
